export default function getAppID() {
  const appID = window.location.pathname.split('/')[1];
  if (appID) {
    return appID;
  }
  return null;
}
